import * as client from '../api/contentful-client';
import * as actions from '../actions/landing';

export const fetchGlowforgeLandingPage = () => ({
  promise: () => client.getPage('glowforge-landing-page'),
  events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_LANDING_PAGE, 'PROMISE_ERROR'],
});

export const fetchProjectPics = albumName => ({
  promise: async http => (http.get(`/storefront/api/yotpo_album?album_name=${albumName}`)),
  events: ['PROMISE_PENDING', actions.SET_PROJECT_PICS, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/api/landing-api.js